import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

import {
  logChatbotConversationCreatedFromStartOver,
  logChatbotErrorMessageAppears,
  logChatbotSendMessage,
} from '../bi';
import { TRootState } from '../common/reducers';
import { chatActions } from '../common/reducers/chat';
import { errorsSlice } from '../common/reducers/errors';
import { fieldActions } from '../common/reducers/field';
import { ResetReason } from '../common/reducers/types';
import { loadAttaches } from '../common/thunks/attaches.thunk';
import { loadSolutions } from '../common/thunks/solutions.thunk';

export const biMiddleware = ({ getState }: MiddlewareAPI<any, TRootState>) => {
  return (next: Dispatch) => (action: AnyAction) => {
    if (loadSolutions.fulfilled.match(action)) {
    } else if (chatActions.updateSession.match(action)) {
      const state = getState();
      const {
        chat: { resetReason, conversationId },
      } = state;

      if (resetReason === ResetReason.StartOver && action.payload.conversationId !== conversationId) {
        logChatbotConversationCreatedFromStartOver(state, {
          destinationConversationId: action.payload.conversationId,
        });
      }
    } else if (errorsSlice.actions.addError.match(action) || loadAttaches.rejected.match(action)) {
      if (action.payload?.bi) {
        logChatbotErrorMessageAppears(getState(), action.payload.bi);
      }
    } else if (fieldActions.sendMessage.match(action)) {
      logChatbotSendMessage(getState(), action.payload.bi);
    }

    return next(action);
  };
};
